import React from "react";
import { motion } from "framer-motion";

export default function BrandRail() {
  return (
    <div
      className="pointer-events-none fixed left-0 top-0 z-40 hidden h-screen w-[72px] items-end justify-center pb-8 sm:flex"
      data-testid="brand-rail"
    >
      <motion.span
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="vertical-rl font-head text-2xl font-semibold tracking-tight text-white"
      >
        Orb Holdings
      </motion.span>
    </div>
  );
}
